module.exports = __webpack_public_path__ + "img/scrap_token.gene.66bd5af.png";